export default "__VITE_ASSET__DMS50bPU__"